import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import loadOpenBids, { defaultParameters } from "@steiner/App/Handlers/XNG/LoadOpenBids";
import { CustomAppState, OpenBidOrderModel } from "@steiner/App/Store/Reducers";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    return {
        openBidOrders: state.xOpenBids.orders,
        isLoading: state.xOpenBids.isLoading,
        pagination: state.xOpenBids.pagination,
        searchParams: state.xOpenBids.searchParams,
    };
};

const mapDispatchToProps = {
    loadOpenBids,
};

export const OpenBidsPageDataContext = React.createContext<{
    orders: OpenBidOrderModel[] | undefined;
}>({
    orders: [],
});

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const OpenBidsPage = ({ id, openBidOrders, isLoading, pagination, searchParams, loadOpenBids }: Props) => {
    React.useEffect(() => {
        if (openBidOrders && !isLoading) {
            loadOpenBids({
                ...defaultParameters,
                ...searchParams,
                pageSize: pagination?.pageSize || pagination?.defaultPageSize || 16,
            });
        }
    }, [searchParams]);

    React.useEffect(() => {
        if (!openBidOrders && !isLoading) {
            loadOpenBids({ ...defaultParameters, pageSize: 16 });
        }
    }, [openBidOrders, isLoading]);

    return (
        <Page data-test-selector="openBids">
            <OpenBidsPageDataContext.Provider value={{ orders: openBidOrders }}>
                <Zone contentId={id} zoneName="Content" />
            </OpenBidsPageDataContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OpenBidsPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "OpenBidsPage" instead of this constant.
 */
export const OpenBidsPageContext = "OpenBidsPage";
